'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCloud, iconCloudTag } from '@ni/nimble-components/dist/esm/icons/cloud';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCloud };
export { iconCloudTag };
export const NimbleIconCloud = wrap(IconCloud);